import React, {useState } from 'react';
import { Form } from '../../common/Form';
import { useTranslation } from 'react-i18next';

export function CourseForm(props)
{
	const {t}=useTranslation();
	const [formData,setFormData]=useState(props.cat);

	const onValChange=(data)=>{
		console.log("onValChange:"+JSON.stringify(data));
		setFormData(data);
		props.onChange(data);		
	}
	return(
		<Form id="formid" formData={formData} onChange={onValChange}
			fields={[
				{id:"code",ftype:"text",field:"code",label:t("Code")},
				{id:"credits",ftype:"number",field:"credits",label:t("Credits")},
				{id:"name",ftype:"text",field:"name",label:t("Name")},
				{id:"descr",ftype:"textarea",field:"descr",label:t("Description")},
			]}>
		</Form>	
	);
}
export default CourseForm;